import { FileReader, FileWriter } from '@/platform'

class Viewport {
    public X: number = 0 // 原点的x坐标
    public Y: number = 0 // 原点的y坐标
    public Width: number = 960 // 限制的宽度
    public Height: number = 540 // 限制的高度

    constructor(x: number = 0, y: number = 0, width: number = 960, height: number = 540) {
        this.X = x
        this.Y = y
        this.Width = width
        this.Height = height
    }

    readBin(reader: FileReader): void {
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.Width = reader.readInt()
        this.Height = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeInt(this.Width)
        writer.writeInt(this.Height)
    }

    readVersionedOui(reader: FileReader): void {
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.Width = reader.readInt()
        this.Height = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeInt(this.Width)
        writer.writeInt(this.Height)
        writer.writerLength()
    }

    writeMallBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}

export default Viewport
